import React, { useState, useContext, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonFab,
  IonFabList,
  IonFabButton,
} from "@ionic/react";
import {
  Icon,
  PlusIcon,
  BriefcaseIcon,
  HomeIcon,
  PersonIcon,
  HistoryIcon,
  RefreshIcon
} from "evergreen-ui";
import { HomeTable } from "../../components/HomeTable";
import { ReferCase } from '../../components/Forms/ReferCase';
import { MyQueries } from '../../components/MyQueries';
import { globalContext } from '../../global/Store';
import dummyUserData from "../../dummyJson/user.json";
// import LogRocket from 'logrocket';

const Home: React.FC = () => {

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const [showReferCaseForm, setShowReferCaseForm] = useState(false);
  const [showMyQueries, setShowMyQueries] = useState(false);
  const [showMyCases, setShowMyCases] = useState(false);
  const [reloadCount, setReloadCount] = useState(0);

  useEffect(() => {

    console.log("home" + globalState.user.userId);

    if(globalState.user.userId === 482) {
      // LogRocket.init('t4vznu/encompass-staging');
      // LogRocket.identify('jason.white@spicerhaart.co.uk', {});
    }
    
  }, []);

  const handleMyQueriesComplete = () => {

    
    setShowMyQueries(false);
  }

  const handleReferCaseComplete = () => {
    console.log("refresh List");
    setReloadCount(reloadCount + 1);
    setShowReferCaseForm(false);
  }

  const handleRefresh = () => {

    setReloadCount(reloadCount + 1);

    globalFunctions.HandleToast({
      header: "Refreshed",
      id: "Case-Read-Success",
      description: "Case list refreshed",
      type: "success",
      error: ''
    });
  }

  return (
    <IonPage style={{ marginTop: "80px" }}>
      <IonContent fullscreen>
        {/* <HomeTable
          // caseRef={this.state.caseRef}
          // saveCaseRef={this.state.caseRef}
        /> */}
        {showReferCaseForm ? <ReferCase  formTitle={"Add"} onReferCaseComplete={handleReferCaseComplete} /> : null}
        {showMyQueries ? <MyQueries onMyQueriesComplete={handleMyQueriesComplete} /> : null}
        {showMyCases ? <HomeTable caseListType={2} reloadList={reloadCount} /> : null}
        {!showMyCases ? <HomeTable caseListType={1} reloadList={reloadCount}  /> : null}

      </IonContent>
      <IonFab
        vertical="bottom"
        horizontal="end"
        edge
        slot="fixed"
        style={{ bottom: "10px", right: "15px" }}
      >
        <IonFabButton style={{ width: "50px", height: "50px" }}>
          <Icon icon={PlusIcon} size={20} color="white" />
        </IonFabButton>
        <IonFabList side="top" style={{ right: "-2px", marginBottom: "60px" }}>
          <IonFabButton title="Refresh" onClick={() => handleRefresh()} style={{ width: "50px", height: "50px" }}>
            <Icon icon={RefreshIcon} size={20} color='#234361' />
          </IonFabButton>
          <IonFabButton
            onClick={() => setShowMyQueries(true)}
            title=" My Queries"
            style={{ width: "50px", height: "50px" }} >
            <Icon icon={HistoryIcon} size={20} color='#234361' />
          </IonFabButton>
          <IonFabButton
            onClick={() => setShowReferCaseForm(true)}
            title="Refer New Case"
            style={{ width: "50px", height: "50px" }}
          >
            <Icon icon={BriefcaseIcon} size={20} color="#234361" />
          </IonFabButton>
          <IonFabButton
            onClick={() => setShowMyCases(true)}
            title="My Cases"
            style={{ width: "50px", height: "50px" }}
          >
            <Icon icon={PersonIcon} size={20} color="#234361" />
          </IonFabButton>
          <IonFabButton
            onClick={() => setShowMyCases(false)}
            title="Home" style={{ width: "50px", height: "50px" }}>
            <Icon icon={HomeIcon} size={20} color="#234361" />
          </IonFabButton>
        </IonFabList>
      </IonFab>
    </IonPage>
  );
};

export default Home;
